import { PureComponent } from 'react'
import S3ImageUploader from './index'
import { convertProposalImagesToUploaderData } from './ImageUploaderHelper'
import WithS3Service from '../../../../containers/Common/WithS3Service'
import withProposalListingFormUploadFiles from '../HOC/withProposalListingFormUploadFiles'
import { mergeFilesByUid, filterFileListByError } from '../../../../lib/uploaderUtil'

const S3ImageUploaderField = WithS3Service(S3ImageUploader)

class ImageUploaderField extends PureComponent {
  handleUploadFile = fileList => {
    const {
      input,
      onUpdate,
      updateUploadFiles
    } = this.props

    const currentImageList = input.value || []

    const nextUploadFiles = filterFileListByError(
      mergeFilesByUid(currentImageList, fileList)
    )

    input.onBlur(onUpdate(nextUploadFiles))
    updateUploadFiles(nextUploadFiles)
  }

  handleFinishFile = fileList => {
    const {
      input,
      onFinish,
      updateUploadFiles
    } = this.props
    input.onChange(onFinish(fileList))
    updateUploadFiles(fileList)
  }

  render () {
    const {
      input = {},
      meta,
      onFinish,
      onUpdate,
      ...restProps
    } = this.props

    const images = input.value || []
    const formattedImages = convertProposalImagesToUploaderData(images)

    return (
      <S3ImageUploaderField
        {...restProps}
        defaultFileList={formattedImages}
        onUpdateFile={this.handleUploadFile}
        onFinish={this.handleFinishFile}
      />
    )
  }
}

const ImageUploaderFieldContainer = withProposalListingFormUploadFiles(ImageUploaderField)

export default ImageUploaderFieldContainer
